import LoginContainer from "../../container/public/LoginContainer.jsx";

const LoginPage = () => {
    return <LoginContainer />;
};

export default LoginPage;
